module.exports = __webpack_public_path__ + "static/media/hemant-shankar.e7c3a105.jpeg";